// eslint-disable-next-line
export const dataTypes = {
  date: 'DATE',
  bool: 'BOOLEAN',
  number: 'NUMBER',
  decimal: 'DECIMAL',
  string: 'STRING',
};
